<template>
    <section
        v-if="!loading && localPublications.length"
        class="publications-section card"
    >
        <h2 class="text-xl font-semibold mb-4">
            {{ $trans("web_profile.publications") }}
        </h2>

        <div v-loading="loading" class="min-h-[200px]">
            <EasyDataTable
                v-if="!loading && localPublications.length"
                :headers="publicationHeaders"
                :items="localPublications"
                table-class-name="custom-publications-table"
                hide-footer
                :border-cell="false"
            >
                <template #empty-message>
                    <div style="text-align: center; padding: 20px; color: #888">
                        {{ $trans("web_profile.no_publications_found") }}
                    </div>
                </template>

                <template #item-open="{ url }">
                    <button class="open-btn" @click="openPublication(url)">
                        {{ $trans("web_profile.open_publication") }}
                        <img
                            style="width: 20px; height: 20px"
                            src="/media/images/open_publication.svg"
                            class="icon"
                        />
                    </button>
                </template>
            </EasyDataTable>
        </div>
    </section>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";

export default {
    name: "PublicationsSection",
    components: { EasyDataTable },

    data() {
        return {
            loading: true,
            localPublications: [],
        };
    },

    computed: {
        ...mapStores(useWebProfileStore),
        publicationHeaders() {
            return [
                { text: this.$trans("web_profile.title"), value: "title" },
                { text: this.$trans("web_profile.language"), value: "language" },
                { text: this.$trans("web_profile.type"), value: "type" },
                { text: "", value: "open", width: 200 },
            ];
        }
    },

    watch: {
        "WebProfileStore.publications": {
            handler(newPublications) {
                if (newPublications) this.mapPublications(newPublications);
            },
            immediate: true,
        },
    },

    methods: {
        mapPublications(rawPublications) {
            this.localPublications = rawPublications.map((pub) => ({
                id: pub.id,
                title: pub.title || "-",
                language: pub.language || "-",
                type: pub.type || "-",
                url: pub.url || null,
            }));

            this.loading = false;
        },

        openPublication(url) {
            if (!url) return;
            window.open(url, "_blank");
        },
    },
};
</script>

<style scoped>
.publications-section {
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
}

:deep(.custom-publications-table) {
    --easy-table-border: none;
    --easy-table-row-border: none;
    --easy-table-header-font-size: 13px;
    --easy-table-body-row-font-size: 13px;
    --easy-table-header-background-color: transparent;
    --easy-table-body-row-background-color: transparent;
    --easy-table-body-row-font-color: #000;
}

:deep(.vue3-easy-data-table__main tr td) {
    background-color: #eaf3f7 !important;
    border: 4.5px solid #fff !important;
    border-radius: 4px;
    font-weight: 700 !important;
    color: #000 !important;
    font-size: 16px !important;
}

:deep(.vue3-easy-data-table__main tr th) {
    background-color: transparent !important;
    border: none !important;
    pointer-events: none;
    padding-left: 10px;
    vertical-align: bottom;
    padding-bottom: 10px;
    font-weight: 700 !important;
    color: #000 !important;
    font-size: 16px !important;
}

:deep(.vue3-easy-data-table__body tr td:last-child) {
    background-color: transparent !important;
}

.open-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    background: #41abc4;
    border: none;
    border-radius: 0;
    padding: 8px 40px 8px 14px;
    font-weight: 700 !important;
    font-size: 16px !important;
    color: #fff;
    cursor: pointer;
    width: 150px;
}

.open-btn .icon {
    position: absolute;
    right: 14px;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 8px;
    width: 40px !important;
    height: 40px !important;
    margin-left: 78px;
}
</style>